<template>
  <section data-test="orderline-details-coverages">
    <div
      v-for="(coverage, index) in coverages"
      :key="index"
      class="pb-56 last:pb-0"
      :data-test="`orderline-details-coverage-${coverage.label}`"
    >
      <h3 v-if="coverage.label" class="heading-3 pb-8">{{ coverage.label }}</h3>

      <div
        v-for="(item, itemIndex) in coverage.coverages"
        :key="itemIndex"
        class="pb-24 last:pb-0"
        :data-test="`orderline-details-sub-coverage-${item.label}`"
      >
        <Coverage :coverage="item" />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { CoveragesProps } from './Coverages.types'
import Coverage from './components/Coverage.vue'

const { coverages } = defineProps<CoveragesProps>()
</script>
